



































import TitleLabel from '../atoms/TitleLabel.vue';
import LoginButton from './LoginButton.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AuthService } from '../../biz/remote/AuthService';
import { ErrorHandler } from '../../utils/ErrorHandler';
import { Session } from '../../utils/Session';
import { UserAuthDTO } from 'src_server/entity/dto/UserAuthDTO';
import { WebUtils } from '../../utils/WebUtils';

@Component({ components: { TitleLabel, LoginButton } })
export default class LoginByMailPage extends Vue {
  mail = '';
  password = '';
  building = '';

  mounted() {
    const linkLogin = this.$route.query.linkLogin as string;
    console.log('login Panel linkLogin' + linkLogin);
  }

  async login() {
    let linkToken = WebUtils.getQueryItem('linkToken', location) || '';
    const biz = new AuthService();
    const result = await biz.loginByMail(this.mail, this.password, linkToken);
    if (result.hasError) {
      ErrorHandler.atResponseError(result);
      return;
    }
    const dto = result.data;
    Session.set<UserAuthDTO>('USER', dto);

    let redirectPath = WebUtils.getQueryItem('redirect', location);
    console.log(redirectPath);
    if (!redirectPath) {
      switch (dto.user_type) {
        case 'tea':
          redirectPath = `/teacher-dashboard-page?building=${dto.building}`;
          break;
        case 'stu':
          redirectPath = `/student-dashboard-page?building=${dto.building}`;
          break;
        case 'adm':
          redirectPath = `/admin-menu-page?building=${dto.building}`;
          break;
        default:
          throw new Error('遷移先が設定できませんでした。');
      }
    }
    this.$router.push(redirectPath);
  }
}
